import { render, staticRenderFns } from "./TitleDescriptionSlot.vue?vue&type=template&id=d08d450e&"
import script from "./TitleDescriptionSlot.vue?vue&type=script&lang=js&"
export * from "./TitleDescriptionSlot.vue?vue&type=script&lang=js&"
import style0 from "./TitleDescriptionSlot.vue?vue&type=style&index=0&id=d08d450e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports